<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'股权融资管理'},{name:'股权融资项目列表',goback:true},{name:'股权融资项目明细'}]" :title="'股权融资项目明细'"/>
            <!-- 选项卡 -->
           
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="项目详情" name="1"></el-tab-pane>
              <el-tab-pane label="约谈记录" name="2"></el-tab-pane>
              <el-tab-pane label="推荐机构" name="3"></el-tab-pane>
            </el-tabs>
            <!-- 主体 -->
            <!-- 项目详情 -->
            <div class="box detailBas" v-show="tab==='1'">
              <el-card class="basic box_card" header="" shadow="never">
                <div class="basisTitle">基本信息</div>
                <el-row>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">项目名称：</div>
                      <div class="content">{{projectDetails.projectName}}</div>
                  </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">简要描述：</div>
                      <div class="content">{{projectDetails.description}}</div>
                  </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">封面LOGO：</div>
                      <div class="content"><img class="logos" :src="projectDetails.frontPath+projectDetails.logo"></div>
                  </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card" header="" shadow="never">
                <div class="basisTitle">概况</div>
                <el-row>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">行业：</div>
                      <div class="content">{{projectDetails.tradeValue}}</div>
                  </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">轮次：</div>
                      <div class="content">{{projectDetails.roundsValue}}</div>
                  </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">出让股权比例：</div>
                      <div class="content">{{projectDetails.equity}}</div>
                  </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">融资金额：</div>
                      <div class="content">{{projectDetails.financingAmount}}</div>
                  </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">公司名称：</div>
                      <div class="content">{{projectDetails.companyName}}</div>
                  </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">项目网址：</div>
                      <div class="content">{{projectDetails.projectUrl}}</div>
                  </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">公司地址：</div>
                      <div class="content">{{projectDetails.companyAddr}}</div>
                  </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">成立时间：</div>
                      <div class="content">{{projectDetails.foundTime}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">项目概述：</div>
                      <div class="content super_p" v-html="projectDetails.projectOutline" v-if="projectDetails.projectOutline"></div>
                      <div class="content" v-else>--</div>
                  </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card" header="" shadow="never">
                <div class="basisTitle">团队</div>
                <el-row>
                  <el-col :span="24">
                    <div class="tableChild">
                    <el-table
                        :data="projectDetails.teamList"
                        max-height="250"
                        :header-cell-style="headerStyle"
                        style="width: 100%">
                        <el-table-column
                            prop="name"
                            label="姓名"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="position"
                            label="职位"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="introduction"
                            show-overflow-tooltip
                            label="介绍">
                        </el-table-column>
                    </el-table>
                </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card" header="" shadow="never">
                <div class="basisTitle">融资情况</div>
                <el-row>
                  <el-col :span="24">
                    <div class="tableChild">
                    <el-table
                        :data="projectDetails.finList"
                        max-height="250"
                        :header-cell-style="headerStyle"
                        style="width: 100%">
                        <el-table-column
                            prop="equityTime"
                            label="时间"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="roundsValue"
                            label="轮次"
                            show-overflow-tooltip
                            >
                        </el-table-column>
                        <el-table-column
                            prop="financingAmount"
                            show-overflow-tooltip
                            label="金额">
                        </el-table-column>
                        <el-table-column
                            prop="mechanism"
                            show-overflow-tooltip
                            label="机构">
                        </el-table-column>
                    </el-table>
                </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card" header="" shadow="never">
                <div class="basisTitle">财务状况</div>
                <el-row>
                  <el-col :span="24">
                      <div class="tableChild">
                    <el-table
                        :data="projectDetails.financeList"
                        max-height="250"
                        :header-cell-style="headerStyle"
                        style="width: 100%">
                        <el-table-column
                            prop="year"
                            label="年份"
                            show-overflow-tooltip
                            >
                        </el-table-column>
                        <el-table-column
                            prop="totalAssets"
                            label="总资产（元）"
                            show-overflow-tooltip
                            >
                        </el-table-column>
                        <el-table-column
                            prop="openIncome"
                            show-overflow-tooltip
                            label="营业收入（元）">
                        </el-table-column>
                        <el-table-column
                            prop="grossProfit"
                            show-overflow-tooltip
                            label="毛利润（元）">
                        </el-table-column>
                        <el-table-column
                            prop="grossProfitRate"
                            show-overflow-tooltip
                            label="毛利润率">
                        </el-table-column>
                        <el-table-column
                            prop="netProfit"
                            show-overflow-tooltip
                            label="净利润（元）">
                        </el-table-column>
                        <el-table-column
                            prop="netProfitRate"
                            show-overflow-tooltip
                            label="净利润率">
                        </el-table-column>
                        <el-table-column
                            prop="totalLiability"
                            show-overflow-tooltip
                            label="总负债（元）">
                        </el-table-column>
                        <el-table-column
                            prop="totalLiabilityRate"
                            show-overflow-tooltip
                            label="负债率">
                        </el-table-column>
                        <el-table-column
                            prop="ownerEquity"
                            show-overflow-tooltip
                            label="所有者权益（元）">
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            show-overflow-tooltip
                            label="从业人数">
                        </el-table-column>
                    </el-table>
                </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card" header="" shadow="never">
                <div class="basisTitle">BP</div>
                <el-row>
                  <el-col :span="24">
                      <div class="attachment">
                        <ul class="content">
                            <li><span>{{projectDetails.bpName}}</span><i class="el-icon-download" @click="opens(projectDetails)"></i></li>
                        </ul>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card" header="" shadow="never">
                <div class="basisTitle">联系方式</div>
                <el-row>
                  <el-col :span="8">
                      <div class="child">
                        <div class="name">项目联系人：</div>
                        <div class="content">{{projectDetails.projectContact}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                      <div class="child">
                        <div class="name">联系手机号：</div>
                        <div class="content">{{projectDetails.contactPhone}}</div>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card" header="" shadow="never">
                <div class="basisTitle">信息采集协议</div>
                <el-row>
                  <el-col :span="8">
                      <div class="child">
                          <div class="name">是否同意《信息采集协议》：</div>
                          <div class="content">是</div>
                      </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card" header="" shadow="never">
                <div class="basisTitle">其它信息</div>
                <el-row>
                  <el-col :span="8">
                      <div class="child">
                        <div class="name">发布账号：</div>
                        <div class="content">{{projectDetails.createUserName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                      <div class="child">
                        <div class="name">发布时间：</div>
                        <div class="content">{{projectDetails.createTime}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                      <div class="child">
                        <div class="name">更新账号：</div>
                        <div class="content">{{projectDetails.modifyUserName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                      <div class="child">
                        <div class="name">更新时间：</div>
                        <div class="content">{{projectDetails.updateTime}}</div>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
            </div>
            <!-- 约谈记录 -->
            <el-table
                v-show="tab==='2'"
                :data="tableData"
                @sort-change="sortChange"
                 ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                style="width: 100%">
                <el-table-column
                    prop="userName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="name"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="intentInvest"
                    show-overflow-tooltip
                    
                    width="200"
                    label="意向投资额">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
            </el-table>
            <!-- 客户申请表格 -->
            <el-table
                v-show="tab==='3'"
                :data="tableData"
                @sort-change="sortChange"
                ref="multipleTable"
                    fit
                    :height="bHeight"
                    :header-cell-style="headerStyle"
                style="width: 100%">
                <el-table-column
                    prop="agencyName"
                    show-overflow-tooltip
                    
                    label="推荐机构名">
                </el-table-column>
                <el-table-column
                    prop="progressStatement"
                    show-overflow-tooltip
                    
                    label="进展说明">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="创建时间">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="更新时间">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="200">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain @click="edit(scope.row)">编辑</el-button>
                        <el-button size="small" type="danger" class="super" plain @click="del(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" v-show="tab!== '1'" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 编辑 -->
            <el-dialog
                title="推荐机构"
                :visible.sync="dialogAudit"
                width="30%">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>机构名称：</div>
                        <div class="content"><el-input v-model="sendInfo.agencyName"></el-input></div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.agencyName']">错误提示：{{errors['sendInfo.agencyName']}}</div>
                    <div class="childTextarea">
                        <div class="name"><span>*</span>进展说明：</div>
                        <div class="content"><el-input type="textarea" v-model="sendInfo.progressStatement" show-word-limit maxlength="200"></el-input></div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.progressStatement']">错误提示：{{errors['sendInfo.progressStatement']}}</div>
                    <div class="doubleBtn">
                        <el-button size="small" type="primary" @click="submit">确认</el-button>
                        <el-button size="small" @click="cancel">取消</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            bHeight: void 0,
            id:'',//详情id
            tab:'1',//选项卡
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogAudit:false,//查看明细弹出层
            sendInfo:{
                id:'',
                equityId:'',
                agencyName:null,//机构名称
                progressStatement :'',//进展说明
            },//审核提交数据
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                equityId:'',
                property:null,//排序字段
                direction:null,//排序方式
            },//检索提交数据
            projectDetails:{
                projectName:"",//项目名称：
                description:"",//简要描述：
                logo:"",//封面LOGO：
                tradeValue:"",//行业：
                roundsValue:"",//轮次：
                equity:"",//出让股权比例：
                financingAmount:"",//融资金额：
                companyName:"",//公司名称：
                projectUrl:"",//项目网址：
                companyAddr:"",//公司地址：
                foundTime:"",//成立时间：
                projectOutline:"",//项目概述
                teamList:[],//团队
                finList:[],//融资情况
                financeList:[],//财务状况
                projectContact:"",//项目联系人：
                contactPhone:"",//联系手机号：
                checkStatusValue:"",//审核结果：
                updateTime:"",//审核时间：
                auditInstructions:"",//说明：
                createUserName:"",//审核账号：
                userVo:{
                    userName:"",//添加人账号
                    userTypeName:"",//账号类型：
                    realName:"",//姓名：
                    email:"",//邮箱：
                    contactAddress:"",//联系地址：
                    realName:"",//姓名：
                }
            },
            totalSize:null
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfo.agencyName':'manageName',
        'sendInfo.progressStatement':{
            test:function(){
                if(this.sendInfo.progressStatement.length>0){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写进展说明'
        },
    },
    methods:{
      opens({bpName,bpPath}){
          const formData = new window.FormData()
          formData.append('fileName', bpPath)
          onDownload(formData,bpName)
       },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        // 切换选项啦
        changeTab:function(tab){
            const that = this
            that.tab=tab.name;
            that.sendInfoOne.currentPage =1
            that.sendInfoOne.pageSize = 20,//页条数
            that.getData();
            if(tab.name !== '1'){
              setTimeout(() => {
                that.$nextTick(() => {
                  let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
              }, 200);
              
            }
        },
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='asc';
            }else{
                order='desc';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        //编辑
        edit:function(row){
            Object.assign(this.sendInfo,row)
            this.sendInfo.equityId = this.projectDetails.id
            this.dialogAudit=true;
        },
        //取消按钮
        cancel:function(){
            this.$vuerify.clear();
            this.dialogAudit=false
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axioscBody.post('backstage/equity/financing/saveAgency',this.sendInfo).then(res=>{
                    if(res.code == 200){
                        this.$message({
                            type: 'success',
                            message: '提交成功'
                        });
                        this.getData();
                        this.dialogAudit=false
                    }else{
                        this.$message({
                            type: 'error',
                            message:res.msg
                        });
                    }
                })
            }
        },
        //删除
        del:function(row){
            this.$confirm('确认删除？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axiosc.get('backstage/equity/financing/delAgency/'+row.id).then(res=>{
                        if(res.code == 200){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                          this.getData()
                        }else{
                            this.$message({
                                type: 'error',
                                message:res.msg
                            });
                        }
                    })
                   
                }).catch(() => {    
            });
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        getData(){
            if(this.tab == 1){
                this.$axiosc.get('backstage/equity/financing/details/'+this.id).then(res=>{
                    if(res.code == 200){
                        this.projectDetails = res.data
                    }else{
                        this.$alert(res.msg)
                    }
                })
            }else{
                this.sendInfoOne.equityId = this.id
                let url = ''
                if(this.tab == 2){
                    url = 'backstage/equity/financing/interview/list'
                }else{
                    url = 'backstage/equity/financing/agency/list'
                }
                this.$axiosc.get(url,{params:this.sendInfoOne}).then(res=>{
                    if(res.code == 200){
                        this.tableData= res.data.content
                        this.totalSize=res.data.totalElements;
                    }else{
                        this.$alert(res.msg)
                    }
                })
            }
        }
    },
    created(){
        if(this.$route.query.id){
            this.id=this.$route.query.id;
            this.sendInfo.id = this.id
            this.getData()
        }
    },
    mounted(){
    const that = this
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
  },
}
</script>

<style lang="scss" scoped>
.warp{
    height: calc(100% - 40px);
    .detailBas{
        margin-top: 20px;
        overflow-x:hidden;
        overflow-y: auto;
        height:calc(100% - 100px);
    }
}
.box{
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
    .tableChild{
      margin-top:8px !important;
    }
    .child,.attachment{
      margin-top:8px;
    }
}
</style>